/**
 * Returns a human‑friendly “time ago” string using your `t` translation function.
 *
 * @param timestamp  Date, ISO string or epoch millis
 * @param t          translation function, expects keys: "seconds","minutes","hours","days","weeks"
 */
export function timeAgo(
  timestamp: Date | string | number,
  t: ( key: string ) => string
): string {
  const now = Date.now();
  const then =
    timestamp instanceof Date
      ? timestamp.getTime()
      : typeof timestamp === 'number'
      ? timestamp
      : new Date( timestamp ).getTime();
  const deltaSec = Math.max( 0, Math.floor(( now - then ) / 1000 ));

  if ( deltaSec < 60 ) {
    return `${deltaSec} ${t( 'seconds' ).charAt( 0 )}`;
  }

  const deltaMin = Math.floor( deltaSec / 60 );
  if ( deltaMin < 60 ) {
    return `${deltaMin} ${t( 'minutes' ).charAt( 0 )}`;
  }

  const deltaHrs = Math.floor( deltaMin / 60 );
  if ( deltaHrs < 24 ) {
    return `${deltaHrs} ${t( 'hours' ).charAt( 0 )}`;
  }

  const deltaDays = Math.floor( deltaHrs / 24 );
  if ( deltaDays < 7 ) {
    return `${deltaDays} ${t( 'days' ).charAt( 0 )}`;
  }

  const deltaWeeks = Math.floor( deltaDays / 7 );
  return `${deltaWeeks} ${t( 'weeks' )}`;
}